'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.version
     * @param {string} params.lang
     * @param {string} params.cntry
     * @param {string} params.sourceCode
     * @param {string} params.login user name
     * @param {string} params.password
     * @param {string} params.verification
     * @returns {Bluebird Promise}
     */
    resetPasswordWithToken: function resetPasswordWithToken(params) {
        return this.postApiRequest(this.getUrl().changePasswordReset, this.pullQueryStringParams(params), params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/changePasswordServiceClient.js
// module id = 837
// module chunks = 0